import { VerificationStore } from './verificaton.store'

const directorVerificationStore = new VerificationStore({ isDirector: true })
export default directorVerificationStore
